import { render, staticRenderFns } from "./dataPage.vue?vue&type=template&id=7a12dba3&scoped=true"
import script from "./dataPage.vue?vue&type=script&lang=js"
export * from "./dataPage.vue?vue&type=script&lang=js"
import style0 from "./dataPage.vue?vue&type=style&index=0&id=7a12dba3&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a12dba3",
  null
  
)

export default component.exports